<ng-container *ngIf="!invoiceListLoading; else pageSpinner">
  <div class="invoice-wrapper">
    <div class="filter-container">
      <!-- SORTING (DESKTOP) -->
      <div class="order-history-sort" *ngIf="invoiceHistoryResults?.length > 0">
        <app-sorting
          [sortOptions]="invoiceSortOptions"
          [sortLabels]="invoiceSortLabels | async"
          (sortListEvent)="sortChange($event)"
          [selectedOption]="invoiceSort"
        >
        </app-sorting>
      </div>
      <!-- SORTING & FILTER (TABLET AND MOBILE) -->
      <div class="filter-wrapper">
        <button class="btn-sort-filter" (click)="toggleSidenav()">
          <mat-icon class="light" svgIcon="filter"></mat-icon>
          {{ 'orders.sortFilter' | cxTranslate }}
        </button>
      </div>
      <!-- EXPORT CSV -->
      <div class="export-file">
        <button class="tertiary-btn" (click)="exportCsv()" *ngIf="invoiceHistoryResults?.length > 0">
          <mat-icon class="light" svgIcon="exportfile"></mat-icon>
          <span>{{ 'orders.exportCsv' | cxTranslate }}</span>
        </button>
      </div>
    </div>
    <ng-container *ngIf="invoiceHistoryResults?.length > 0; else noResultsFound">
      <!-- INVOICE LIST -->
      <div class="invoice-table">
        <table class="table table-striped">
          <thead>
            <tr>
              @for (header of invoiceHeaders; track $index) {
              <th scope="col" [ngClass]="header.styleClass">
                {{ header.invoiceTableHeader | cxTranslate }}
              </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (invoice of invoiceHistoryResults; track $index) {
            <tr class="invoice-row" (click)="openPdf(invoice.downloadLink)">
              <td>{{ invoice.referenceNumber }}</td>
              <td class="invoice-date">{{ invoice.invoiceDate | date : dateFormatted }}</td>
              <td>{{ invoice.orderNumber }}</td>
              <td class="order-type">{{ invoice.orderType }}</td>
              <td class="po-number">{{ invoice.poNumber }}</td>
              <td class="total-amount">{{ invoice.totalAmount.formattedValue }}</td>
              <td class="payment-status">{{ invoice.paymentStatusDisplay }}</td>
              <td class="due-date">{{ invoice.date | date : dateFormatted }}</td>
              <td class="days-overdue">{{ invoice.daysOverdue }}</td>
              <td class="total-open">{{ invoice.totalOpen.formattedValue }}</td>
              <td class="download-pdf" (click)="downloadPdf($event, invoice.downloadLink)">
                <button class="tertiary-btn export-file">
                  <mat-icon class="light" svgIcon="exportfile"></mat-icon>
                  <span>{{ 'orders.pdf' | cxTranslate }}</span>
                </button>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      <!-- INFINITE SCROLL -->
      <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="1000" (scrolled)="onScroll()"></div>
      <mat-spinner *ngIf="infiniteScrollInProgress" [diameter]="72"></mat-spinner>
    </ng-container>
  </div>
</ng-container>

<ng-template #noResultsFound>
  <div class="no-results">
    <p>{{ 'orders.noResultsFound' | cxTranslate }}</p>
  </div>
</ng-template>

<ng-template #pageSpinner>
  <div class="results-spinner">
    <mat-spinner [diameter]="72"></mat-spinner>
  </div>
</ng-template>
